// @flow
import { TextDecoder } from 'text-encoding';

class Server {
  base_url: string;

  constructor() {
    let servlet = process.env.REACT_APP_CUSTOM_SERVLET
    if (!servlet) {
      if (process.env.REACT_APP_GRID_WIDTH == 5) {
        servlet = "MH_mini/netmini";
      }
      else if (process.env.REACT_APP_GRID_WIDTH == 15) {
        servlet = "MH_kruis/netcrossword";
      }
    }
    const baseUrl = process.env.REACT_APP_BASE_URL || "https://pzzl.net/servlet"
    this.base_url = baseUrl + "/" + servlet;
  }

  getUrl(url: string, params: Object) {
    var qstr = '?' +
        Object.keys(params)
              .map(k => encodeURIComponent(k) + '=' +
                        encodeURIComponent(params[k]))
              .join('&');

    return url + qstr;
  }

  doFetch(params: Object) {
    return fetch(this.getUrl(this.base_url, params), {
      method: 'GET'
    });
  }

  getPuzzle(id: string) {
    var params = {};
    if (id) {
      params['date'] = id;
    }
    return this.doFetch(params).then(function(response) {
      return response.arrayBuffer();
    }).then(function(buf) {
      // $FlowFixMe
      return new TextDecoder('iso-8859-1').decode(buf);
    });
  }

  getPuzzleList() {
    const params = {
      date: 'list',
      get: 'archivecurrent'
    }
    return this.doFetch(params).then((response) => response.text());
  }

  getPrintUrl(id, type) {
    const params = {
      pm: 'pdf',
      puzzle: id,
      data: '<NAME>' + id + '</NAME>' +
            '<TYPE>' + type + '</TYPE>'
    }
    return this.getUrl(this.base_url + "PDF", params);
  }
}

export default Server
